<template>
    <div class="avatars" v-if="users && users.length > 0">
        <avatar v-for="user in users" :user="user" :key="user.id"></avatar>
    </div>
</template>

<script>
    export default {
        props: {
            users: {
                default: null,
            },
        },
        data () {
            return {

            }
        },
        mounted() {
        }
    }
</script>


<style lang="scss">
    .avatars{
        margin-left: .75rem;
        
        > .avatar{
            margin-left: -.75rem;
        }

        > .v-popover{
            margin-left: -.75rem;
            position: relative;
            align-items: flex-start;
            display: inline-flex;
            vertical-align: top;
        }
    }
</style>